module.exports = __webpack_public_path__ + "static/media/np_subscription_456173_A0A0A0.33e85ec2.svg";